import {Collapse, Grid} from "@mui/material";
import {useCallback, useState} from "react";
import MhdSelect from "../../atomicComponents/MhdSelect";
import {euvFilterChoices, mapResolutionChoices} from "../../../utils/choices";
import MhdInput from "../../atomicComponents/MhdInput";
import WidgetSwitch from "../../atomicComponents/WidgetSwitch";
import {setAndUpdate, validateAndUpdate} from "../../../utils/helpers";
import MhdWidgetDivider from "../../atomicComponents/MhdWidgetDivider";
import MhdNestedSelect from "../../atomicComponents/MhdNestedSelect";

const SliceWidget = ({data, mods, warn, errs, update, setter}) => {
  const [customizeStyle, setCustomizeStyle] = useState(false)


  return (
    <Grid container spacing={1}>
      <Grid item xs={4}>
        <WidgetSwitch
          label="Custom View"
          value={data.custom_view}
          onChange={useCallback((v) => setAndUpdate("custom_view", v, setter, update), [])}
        />
      </Grid>
      <Grid item xs={8}>
        <MhdNestedSelect
          label="Filter"
          value={data.euv_filter}
          override={mods.euv_filter}
          warning={warn.euv_filter}
          error={errs.euv_filter}
          onChange={useCallback((v) => setAndUpdate("euv_filter", v, setter, update), [])}
          choices={euvFilterChoices}
        />
      </Grid>
      <Collapse in={data.custom_view}>
        <Grid container spacing={1} pl={1} pt={1}>
          <Grid item xs={6}>
            <MhdInput
              label='Longitude'
              value={data.longitude}
              override={mods.longitude}
              warning={warn.longitude}
              error={errs.longitude}
              onChange={useCallback((v) => validateAndUpdate("longitude", v, setter, update), [])}
              units='°'
            />
          </Grid>
          <Grid item xs={6}>
            <MhdInput
              label='B Angle'
              value={data.b_angle}
              override={mods.b_angle}
              warning={warn.b_angle}
              error={errs.b_angle}
              onChange={useCallback((v) => validateAndUpdate("b_angle", v, setter, update), [])}
              units='°'
            />
          </Grid>
          <Grid item xs={6}>
            <MhdInput
              label='P Angle'
              value={data.p_angle}
              override={mods.p_angle}
              warning={warn.p_angle}
              error={errs.p_angle}
              onChange={useCallback((v) => validateAndUpdate("p_angle", v, setter, update), [])}
              units='°'
            />
          </Grid>
          <Grid item xs={6}>
            <MhdInput
              label='Radial Distance'
              value={data.r_distance}
              override={mods.r_distance}
              warning={warn.r_distance}
              error={errs.r_distance}
              onChange={useCallback((v) => validateAndUpdate("r_distance", v, setter, update), [])}
              units='AU'
            />
          </Grid>
        </Grid>
      </Collapse>
      <Grid item xs={12}>
        <MhdWidgetDivider
            label="CUSTOMIZE STYLE"
            value={customizeStyle}
            onChange={setCustomizeStyle}
        >
          <Collapse in={customizeStyle} >
            <Grid container spacing={1} pt={"2px"}>
              <Grid item xs={4}>
                <WidgetSwitch
                  label="Apply Vignette"
                  value={data.vignette_function}
                  onChange={useCallback((v) => setAndUpdate("vignette_function", v, setter, update), [])}
                />
              </Grid>
              <Grid item xs={4}>
                <MhdInput
                  label='Radial Power'
                  value={data.radial_power}
                  override={mods.radial_power}
                  warning={warn.radial_power}
                  error={errs.radial_power}
                  onChange={useCallback((v) => validateAndUpdate("radial_power", v, setter, update), [])}
                />
              </Grid>
              <Grid item xs={4}>
                <WidgetSwitch
                  label="Logscale"
                  value={data.log_transform}
                  onChange={useCallback((v) => setAndUpdate("log_transform", v, setter, update), [])}
                />
              </Grid>
              <Grid item xs={4}>
                <WidgetSwitch
                  label="Show Orientation"
                  value={data.show_hpc_orientation}
                  onChange={useCallback((v) => setAndUpdate("show_hpc_orientation", v, setter, update), [])}
                />
              </Grid>
              <Grid item xs={4}>
                <WidgetSwitch
                  label="Show Simulation R0"
                  value={data.show_sim_lower_boundary}
                  onChange={useCallback((v) => setAndUpdate("show_sim_lower_boundary", v, setter, update), [])}
                />
              </Grid>
              <Grid item xs={4}>
                <WidgetSwitch
                  label="Show Simulation R1"
                  value={data.show_sim_upper_boundary}
                  onChange={useCallback((v) => setAndUpdate("show_sim_upper_boundary", v, setter, update), [])}
                />
              </Grid>
              <Grid item xs={12}>
                <MhdSelect
                  label="Map Resolution"
                  value={data.resolution}
                  override={mods.resolution}
                  warning={warn.resolution}
                  error={errs.resolution}
                  onChange={useCallback((v) => setAndUpdate("resolution", v, setter, update), [])}
                  choices={mapResolutionChoices}
                />
              </Grid>
            </Grid>
          </Collapse>
        </MhdWidgetDivider>
      </Grid>
    </Grid>
  );
}

export default SliceWidget;